import React, { FC } from 'react';

import { MobileSdkPlatformPage } from 'src/apps/mobile-sdk/pages/all-tesks/MobileSdkPlatformPage';
import { ProductType } from 'src/common/interfaces/Tenant';
import { DashboardContainer } from 'src/common/pages/dashboards-container/DashboardContainer';

export const DashboardContainerMobileSDK: FC = () => (
	<DashboardContainer product={ProductType.MOBILE_SDK}>
		<MobileSdkPlatformPage />
	</DashboardContainer>
);
